import React from "react";
import { FaCheck } from "react-icons/fa";

const ExpertBenefits = () => {
  return (
    <div className="bg-gray-100 py-20">
      <div className="font-josefin-sans max-w-3xl mx-auto px-4">
        <p className="text-3xl py-2 px-4 text-center mb-6">
          As a problem solver, we respect you, your time, and your contribution.
          However, all the benefits will depend on your quality contribution and
          user satisfaction.
        </p>
        <h2 className="text-2xl font-bold mb-6">Grow like a Pro</h2>
        <ul className="space-y-4 text-xl">
          <li className="flex items-baseline">
            <FaCheck className="text-green-500 mr-3 h-4 w-4 flex-shrink-0" />
            <span>
              Solve the first five problems with a collective rating of 4+ to
              upgrade your session price
            </span>
          </li>
          <li className="flex items-baseline">
            <FaCheck className="text-green-500 mr-3 h-4 w-4 flex-shrink-0" />
            <span>
              Get a top-quality video platform for a smooth call experience
            </span>
          </li>
          <li className="flex items-baseline">
            <FaCheck className="text-green-500 mr-3 h-4 w-4 flex-shrink-0" />
            <span>
              Use cutting-edge technology to solve problems efficiently like AI,
              AR, 3D, software, and simulation among others
            </span>
          </li>
          <li className="flex items-baseline">
            <FaCheck className="text-green-500 mr-3 h-4 w-4 flex-shrink-0" />
            <span>Amount transfer at the end of the month</span>
          </li>
          <li className="flex items-baseline">
            <FaCheck className="text-green-500 mr-3 h-4 w-4 flex-shrink-0" />
            <span>
              Get other perks like Smart hardware and a dedicated helpline to
              become a pro at solving problems online
            </span>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default ExpertBenefits;
